import React, { createContext, useEffect, useState } from 'react';
import { getLicense } from '../api';

export const AppContext = createContext();

const AppProvider = ({ children, licenseId }) => {
  const [filterCategories, setFilterCategories] = useState([]);
  const [context, setContext] = useState(null);

  useEffect(() => {
    const fetchTypes = async () => {
      try {
        const data = await getLicense(licenseId);

        setContext(data['license']);
        setFilterCategories(data['filter_categories']);
      } catch (error) {
        console.error('Error fetching types:', error);
      }
    };

    fetchTypes();
  }, [licenseId]);

  useEffect(() => {
    if (!context?.name) return;

    // The register name is feature-flag resolved on app.epass, so host pages
    // must not hardcode it. Only elements opting in via [data-register-name]
    // are updated; a value of "public" requests the "Public " prefix.
    document.querySelectorAll('[data-register-name]').forEach((element) => {
      const prefix =
        element.getAttribute('data-register-name') === 'public'
          ? 'Public '
          : '';
      element.textContent = `${prefix}${context.name}`;
    });
  }, [context]);

  if (!context?.id) return null;

  return (
    <AppContext.Provider
      value={{
        context,
        filterCategories,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppProvider;
